import { Link, useSearchParams } from 'react-router-dom';
import TeletLogo from 'src/assets/logo/tellet-logo-main.svg';
import { StatusCodes } from 'http-status-codes';
import { getErrorMessage, getErrorStatus } from '@common/utils';
import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from '@common/constants';
import Image from '@/components/atoms/Image';
import { Button, buttonVariants } from '@/components/ui/button';
import { useMutateResendEmailInvitation } from '@/reactQuery/post';
import Routes from '@/router/routes';
import ToastMessage from '@/components/toast-message/ToastMessage';

function VerificationCheckYourEmail() {
  const { mutateAsync: mutateAsyncResend, isPending } = useMutateResendEmailInvitation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const onResendSent = async () => {
    try {
      await mutateAsyncResend(email);
      toast.success(
        <ToastMessage
          title="Invitation sent"
          description="Please check your email to confirm registration."
          isAuthScreen
        />,
      );
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      const errorStatus = getErrorStatus(err);
      if (errorStatus === StatusCodes.TOO_MANY_REQUESTS) {
        toast.error(
          <ToastMessage
            title="Error"
            description={ERROR_MESSAGES.VERIFICATION_EMAIL_ALREADY_SENT}
            isAuthScreen
          />,
        );
      } else {
        toast.error(errorMessage);
      }
    }
  };

  return (
    <main className="flex items-center justify-center w-full h-full min-h-screen text-center bg-light-pink">
      <div className="w-full max-w-[600px] min-h-screen center border-0 px-2 py-4 min450:bg-white min450:max-w-full">
        <div className="flex flex-col items-center w-full max-w-[600px] rounded-md h-fit p-7 min450:p-5">
          <div className="flex flex-col items-center w-full ring-1 ring-neutral-200 min450:ring-transparent min450:shadow-none min450:p-5 max-w-[500px] gap-10 bg-white rounded-md shadow-md h-fit p-7">
            <Image effect="blur" src={TeletLogo} alt="logo" width={115} height={37} />

            <h1 className="text-xl font-bold">Verify your Email</h1>
            <p className="text-[#5a6a85] leading-6">
              When you click the button, a verification email will be sent to you. Please open the
              email and click the link to verify your account.
            </p>

            <div className="flex flex-col items-center justify-center w-full gap-2">
              <Button onClick={onResendSent} className="w-full" disabled={isPending}>
                Resend Email Verification
              </Button>
              <Link
                to={Routes.login.path}
                className={buttonVariants({
                  variant: 'ghost',
                  className: 'transition-all w-full ease-in-out',
                })}
              >
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default VerificationCheckYourEmail;
